// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createAdminAuctionSettings = (client) => ({
    /**
     * `GET /admin/auction-settings`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminAuctionSettingsGet
     * @source packages/medusa-plugin-auction-v2/src/api/admin/auction-settings/route.ts
     */
    list: (query, headers) => client.fetch("/admin/auction-settings", { method: "GET", query, headers }),
    /**
     * `PATCH /admin/auction-settings`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminAuctionSettingsPatch
     * @source packages/medusa-plugin-auction-v2/src/api/admin/auction-settings/route.ts
     */
    update: (body, query, headers) => client.fetch("/admin/auction-settings", { method: "PATCH", body, query, headers }),
});
//# sourceMappingURL=auction-settings.js.map